import { useCallback, useEffect, useState } from "react";
import { getJustificacionPerforadora } from "../../services/justificacion";

export function useGetJustificacionPerforadora(idAreaOperacion, inicioMes, finMes) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      if (idAreaOperacion !== 29) {
        return;
      }

      const data = await getJustificacionPerforadora(idAreaOperacion, inicioMes, finMes);

      if (data.status === "success") {
        setData(data.data);
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError("Ha ocurrido un error al intentar obtener los datos");
    } finally {
      setLoading(false);
    }
  }, [idAreaOperacion, inicioMes, finMes]);

  useEffect(() => {
    fetchData();
  }, [idAreaOperacion, inicioMes, finMes, fetchData]);

  return { 
    justificacionPerforadora: data, 
    loadingJustificacionPerforadora: loading, 
    errorJustificacionPerforadora: error 
  };
}
